import React from 'react';
import { Redirect } from 'react-router-dom';

import { RouterError } from '~src/bootstrap/routerHelpers/RouterError';
import { Favorites } from '~src/favorites/resources/Favorites';
import { ISimulationDetailInfo } from '~src/simulation/models/ISimulationInfo';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { Simulations } from '../resources/Simulations';

export interface SimulationSpaceFavoriteRedirectProps {
  readonly simulationId: string;
  readonly urls: SpacesSiteUrls;
}

type SimulationStatus = 'unfetched' | 'fetched' | 'error';

export const SimulationSpaceFavoriteRedirect: React.FunctionComponent<SimulationSpaceFavoriteRedirectProps> = props => {
  const [ simulationStatus, setSimulationStatus ] = React.useState<SimulationStatus>('unfetched');

  React.useEffect(
    () => {
      let didCancel = false;

      fetchSimulation(props.simulationId)
        .then(() => !didCancel && setSimulationStatus('fetched'))
        .catch(() => {
          removeFavoriteSimulation(props.simulationId);
          !didCancel && setSimulationStatus('error');
        });

      return () => didCancel = true;
    },
    [props.simulationId]
  );

  if (simulationStatus === 'unfetched') {
    return null;
  } else if (simulationStatus === 'fetched') {
    return <Redirect to={props.urls.simulationPath(props.simulationId)}/>;
  } else {
    return <RouterError errorType={'simulation-removed-favorite'} urls={props.urls} />;
  }
};

async function fetchSimulation(simulationId: string): Promise<ISimulationDetailInfo> {
  return Simulations.getById(simulationId);
}

function removeFavoriteSimulation(simulationId: string) {
  Favorites.remove(simulationId, 'simulation');
}
